import axios from 'axios';
import { X_API_KEY } from '../utils/authentication';
import i18n from '../i18n';

const apiVersion = "v1"
// from the root of the site
let apiUrl = `${window.location.origin}/t4t/api/${apiVersion}`;

const projectsAction = "projects";

function getApiBaseUrl() {
    return apiUrl;
}

export function getProjectsApiUrl() {
    return `/`;
}

export function getProjectBrandUrl(){
    return `/getbranding`;
}

export function getProjectApiUrl(projectId) {
    return `/${projectId}`;
}

export function putProjectApiUrl(projectId, project) {
    return `/${projectId}?${serializeParams(project)}`;
}

export function postProjectsApiUrl(project) {
    return `?${serializeParams(project)}`;
}

export function copyProjectApiUrl(id, name) {
    return `/${id}/copy?name=${name}`;
}

export function verifyProjectApiUrl(projectId) {
    return `/${projectId}/verify`;
}

export function generateProjectApiUrl(projectId) {
    return `/${projectId}/generate`;
}

export function downloadProjectApiUrl(projectId, downloadId) {
    return `/${projectId}/productionfile?downloadId=${downloadId}`;
}

export function importProjectApiUrl() {
    return `/import`;
}

export function luminaireImageProjectApiUrl(projectId) {
    return `/${projectId}/luminaireimage`;
}

export function luminaireImageProjectApiUrlCompleted(projectId) {
    return `${getApiBaseUrl()}/${projectsAction}/${projectId}/luminaireimage`;
}

export function projectOptionsApiUrl(projectId) {
    return `/${projectId}/options`;
}

export function getProjectLocationApiUrl(projectId) {
    return `/${projectId}/location`;
}

export function putProjectLocationApiUrl(projectId) {
    return `/${projectId}/location`;
}

export function getProjectReportApiUrl(projectId) {
    return `/${projectId}/report`;
}

export function getallVersionsApiUrl() {
    return `${getApiBaseUrl()}/version/all`;
}

export function getHeaderWarningUrl() {
    return `${getApiBaseUrl()}/version/msg`;
}

export function searchProjectsApiUrl(searchString, filterObject) {
    let filterArray = [];
    Object.keys(filterObject).forEach((k) => {
        if (filterObject[k] === true) {
            filterArray.push(k);
        }
    });
    let url = `${projectsAction}?offset=-1&limit=20&search=${searchString}&filter=${filterArray.toString()}`;
    return url;
}

function serializeParams(obj) {
    return Object.entries(obj).map(([key, val]) => val != null ? `${key}=${val}` : `${key}=`).join('&');
}

const instance = axios.create({
    baseURL: `${getApiBaseUrl()}/${projectsAction}`,
    timeout: 30000,
    headers: { 'Access-Control-Allow-Origin': '*', 'CLIENT-ID': "Frontend" }
});

instance.interceptors.request.use(config => {
    if (localStorage.getItem(X_API_KEY) !== null && typeof localStorage.getItem(X_API_KEY) === 'string' && localStorage.getItem(X_API_KEY) !== '') {
        config.headers['X-API-KEY'] = localStorage.getItem(X_API_KEY);
        config.headers['X-LANG'] =  i18n.language;
    } else {
        delete config.headers['X-API-KEY'];
        config.headers['X-LANG'] =  i18n.language;
    }
    return config;
});

export default instance;
